"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("@seedlang/constants");
var _lodash = require("lodash");
var _moment = _interopRequireDefault(require("moment"));
var _reactive_date_decorator = _interopRequireDefault(require("./reactive_date_decorator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // reminder to not import AppUI to avoid circular dependencies
// After one lapse, the next successful review can recover part of the old interval once.
var RECOVERY_FACTOR_GOOD = 0.25;
var RECOVERY_FACTOR_EASY = 0.5;
var ELAPSED_TIME_CREDIT_EASY = 0.75; // share of elapsed days that counts toward interval growth when late (Easy)
var ELAPSED_TIME_CREDIT_GOOD = 0.5; // share for Good
var ELAPSED_TIME_CREDIT_DEFAULT = 0.25; // share for other scores
var DEFAULT_GOOD_INTERVAL_CAP_DAYS = 135;
var SpacedRepetition = /*#__PURE__*/function () {
  function SpacedRepetition() {
    _classCallCheck(this, SpacedRepetition);
    this.dayInMs = 24 * 60 * 60 * 1000;
  }
  return _createClass(SpacedRepetition, [{
    key: "effectiveNowDate",
    value: function effectiveNowDate(reviewTimeOffsetMs) {
      return new Date(Date.now() + (reviewTimeOffsetMs || 0));
    }
  }, {
    key: "onResetSpacedRepetition",
    value: function onResetSpacedRepetition(obj) {
      obj.set('easinessFactor', 2.5);
      obj.set('consecutiveGoodScores', 0);
      obj.set('repetitionInterval', null);
      obj.set('reviewAfter', new _reactive_date_decorator["default"](new Date()));
      obj.set('hadPositiveScore', false);
      obj.set('viewsCount', 0);
      obj.set('lastStableInterval', null);
    }
  }, {
    key: "goodIntervalCapDays",
    value: function goodIntervalCapDays(obj) {
      var daysUntilReviewRetired = obj.daysUntilReviewRetired;
      if (daysUntilReviewRetired == null || Number.isNaN(Number(daysUntilReviewRetired)) || Number(daysUntilReviewRetired) <= 0) {
        return DEFAULT_GOOD_INTERVAL_CAP_DAYS;
      }
      return Math.round(Number(daysUntilReviewRetired) * 0.75);
    }
  }, {
    key: "applyRecallResult",
    value: function applyRecallResult(qualityOfRecall, obj, forceReviewAfterDue, reviewTimeOffsetMs) {
      var reviewsDueAtBeginningOfDay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      if (qualityOfRecall === _constants.Constants.BAD_SCORE) {
        obj.set('lastStableInterval', obj.lastStableInterval ? null : obj.repetitionInterval || null);
        obj.set('lastScore', 0);
        obj.set('repetitionInterval', 0);
        obj.set('consecutiveGoodScores', 0);
        obj.set('reviewAfter', new _reactive_date_decorator["default"]((0, _moment["default"])(this.effectiveNowDate(reviewTimeOffsetMs)).add(1, 'minutes').toDate()));
      } else {
        var repetitionInterval = this.processRecallResult(qualityOfRecall, obj, true, forceReviewAfterDue, reviewTimeOffsetMs, reviewsDueAtBeginningOfDay);
        obj.set('repetitionInterval', repetitionInterval);
        obj.set('reviewAfter', new _reactive_date_decorator["default"]((0, _moment["default"])(this.effectiveNowDate(reviewTimeOffsetMs)).add(repetitionInterval * 24, 'hours').toDate()));
        obj.set('lastScore', qualityOfRecall);
        obj.set('hadPositiveScore', true);
        obj.set('consecutiveGoodScores', obj.consecutiveGoodScores + 1);
        if (obj.lastStableInterval) {
          obj.set('lastStableInterval', null);
        }
      }
      obj.set('viewsCount', obj.viewsCount + 1);
    }
  }, {
    key: "reviewInterval",
    value: function reviewInterval(qualityOfRecall, obj, forceReviewAfterDue, reviewTimeOffsetMs) {
      var reviewsDueAtBeginningOfDay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      if (qualityOfRecall === _constants.Constants.BAD_SCORE) {
        return _constants.Constants.REVIEW_BAD_SCORE_IN_MINUTES;
      }
      return this.processRecallResult(qualityOfRecall, obj, null, forceReviewAfterDue, reviewTimeOffsetMs, reviewsDueAtBeginningOfDay);
    }
  }, {
    key: "processRecallResult",
    value: function processRecallResult(qualityOfRecall, obj, update, forceReviewAfterDue, reviewTimeOffsetMs) {
      var reviewsDueAtBeginningOfDay = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
      // https://apps.ankiweb.net/docs/manual.html#what-spaced-repetition-algorithm-does-anki-use
      var updatedConsecutiveGoodScores;
      var updatedRepetitionInterval;
      var updatedEasinessFactor = this.calculateEasinessFactor(obj.easinessFactor, qualityOfRecall);
      if (update) {
        obj.set('easinessFactor', updatedEasinessFactor);
      }
      if (qualityOfRecall === _constants.Constants.BAD_SCORE) {
        updatedRepetitionInterval = 0;
        updatedConsecutiveGoodScores = 0;
      }
      // If the card has just lapsed once, use the pre-lapse interval for a single
      // recovery review before clearing it in applyRecallResult().
      if (obj.lastStableInterval) {
        updatedRepetitionInterval = this.relearningInterval(obj.lastStableInterval, qualityOfRecall);
      } else if (obj.viewsCount === 0 || obj.consecutiveGoodScores === 0) {
        return qualityOfRecall === _constants.Constants.GOOD_SCORE ? 1 : 4;
      } else {
        updatedConsecutiveGoodScores = obj.consecutiveGoodScores + 1;
        if (updatedConsecutiveGoodScores === 1) {
          updatedRepetitionInterval = 1;
        } else if (!forceReviewAfterDue && this.isBeforeReviewDay(obj.reviewAfter.dateObj, reviewTimeOffsetMs, reviewsDueAtBeginningOfDay)) {
          if (obj.lastScore === qualityOfRecall) {
            updatedRepetitionInterval = obj.repetitionInterval;
          } else if (obj.lastScore === 3 && qualityOfRecall === 5) {
            updatedRepetitionInterval = obj.repetitionInterval * 2;
          } else {
            updatedRepetitionInterval = obj.repetitionInterval / 2;
          }
        } else {
          var effectiveInterval = this.effectiveIntervalForSuccessfulReview(obj, qualityOfRecall, reviewTimeOffsetMs);
          updatedRepetitionInterval = effectiveInterval * updatedEasinessFactor;
          if (qualityOfRecall === _constants.Constants.EASY_SCORE) {
            updatedRepetitionInterval *= 1.5;
          } else {
            updatedRepetitionInterval *= 0.9;
          }
          var fuzz = (0, _lodash.random)(0.9, 1.1);
          updatedRepetitionInterval *= fuzz;
          if (obj.repetitionInterval && updatedRepetitionInterval < obj.repetitionInterval + 1) {
            updatedRepetitionInterval = obj.repetitionInterval + 1;
          }
        }
      }
      var days;
      if (reviewsDueAtBeginningOfDay) {
        days = Math.round(updatedRepetitionInterval);
      } else {
        days = Math.round(updatedRepetitionInterval * 10) / 10;
      }
      days = Math.max(days, this.successBaselineInterval(qualityOfRecall));
      if (qualityOfRecall === _constants.Constants.GOOD_SCORE) {
        days = Math.min(days, this.goodIntervalCapDays(obj));
      }
      return days;
    }
  }, {
    key: "relearningInterval",
    value: function relearningInterval(lastStableInterval, qualityOfRecall) {
      return this.boundedRecoveryInterval(lastStableInterval, 1, qualityOfRecall);
    }
  }, {
    key: "boundedRecoveryInterval",
    value: function boundedRecoveryInterval(lastStableInterval, minimumInterval, qualityOfRecall) {
      // Recovery should stay above the normal fresh-review floor, but still scale up
      // from the old interval and reward Easy more than Good.
      var baselineInterval = this.successBaselineInterval(qualityOfRecall);
      var boundedMinimum = Math.max(minimumInterval, baselineInterval);
      var adjustedRecoveryFactor = qualityOfRecall === _constants.Constants.EASY_SCORE ? RECOVERY_FACTOR_EASY : RECOVERY_FACTOR_GOOD;
      var fuzzedInterval = lastStableInterval * adjustedRecoveryFactor * (0, _lodash.random)(0.9, 1.1);
      return Math.max(boundedMinimum, fuzzedInterval);
    }
  }, {
    key: "successBaselineInterval",
    value: function successBaselineInterval(qualityOfRecall) {
      if (qualityOfRecall === _constants.Constants.GOOD_SCORE) {
        return 1;
      }
      if (qualityOfRecall === _constants.Constants.EASY_SCORE) {
        return 4;
      }
      return 1;
    }

    // Successful due reviews now take real elapsed time into account, so reviewing a card
    // late and still remembering it can grow the next interval more than an on-time review.
  }, {
    key: "effectiveIntervalForSuccessfulReview",
    value: function effectiveIntervalForSuccessfulReview(obj, qualityOfRecall, reviewTimeOffsetMs) {
      var _obj$reviewAfter;
      var scheduledInterval = obj.repetitionInterval || 0;
      if (!scheduledInterval || !((_obj$reviewAfter = obj.reviewAfter) !== null && _obj$reviewAfter !== void 0 && _obj$reviewAfter.dateObj)) {
        return scheduledInterval;
      }
      var elapsedDays = this.elapsedDaysSinceLastReview(obj.reviewAfter.dateObj, scheduledInterval, reviewTimeOffsetMs);
      var creditFactor = this.elapsedTimeCreditFactor(qualityOfRecall);
      return Math.max(scheduledInterval, elapsedDays * creditFactor);
    }
  }, {
    key: "elapsedDaysSinceLastReview",
    value: function elapsedDaysSinceLastReview(reviewAfterDate, scheduledInterval, reviewTimeOffsetMs) {
      var lastReviewedAt = new Date(reviewAfterDate.getTime() - scheduledInterval * this.dayInMs);
      return Math.max(0, (0, _moment["default"])(this.effectiveNowDate(reviewTimeOffsetMs)).startOf('day').diff((0, _moment["default"])(lastReviewedAt).startOf('day'), 'days'));
    }
  }, {
    key: "isBeforeReviewDay",
    value: function isBeforeReviewDay(reviewAfterDate, reviewTimeOffsetMs) {
      var reviewsDueAtBeginningOfDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (reviewsDueAtBeginningOfDay) {
        return (0, _moment["default"])(this.effectiveNowDate(reviewTimeOffsetMs)).startOf('day').isBefore((0, _moment["default"])(reviewAfterDate).startOf('day'));
      }
      return (0, _moment["default"])(this.effectiveNowDate(reviewTimeOffsetMs)).isBefore((0, _moment["default"])(reviewAfterDate));
    }
  }, {
    key: "elapsedTimeCreditFactor",
    value: function elapsedTimeCreditFactor(qualityOfRecall) {
      if (qualityOfRecall === _constants.Constants.EASY_SCORE) {
        return ELAPSED_TIME_CREDIT_EASY;
      }
      if (qualityOfRecall === _constants.Constants.GOOD_SCORE) {
        return ELAPSED_TIME_CREDIT_GOOD;
      }
      return ELAPSED_TIME_CREDIT_DEFAULT;
    }
  }, {
    key: "calculateEasinessFactor",
    value: function calculateEasinessFactor(easinessFactor, qualityOfRecall) {
      // I don't want the lowest score to not affect easiness factor
      if (easinessFactor === 0) {
        easinessFactor = 1;
      }
      var result = easinessFactor - 0.8 + 0.28 * qualityOfRecall - 0.02 * qualityOfRecall * qualityOfRecall;
      return result < 1.3 ? 1.3 : Math.round(result * 10) / 10;
    }
  }]);
}();
var _default = exports["default"] = new SpacedRepetition();